module.exports = __webpack_public_path__ + "static/media/video.2945203a.mp4";